import { SearchableSelectBox } from "@root/shared/components/SearchableSelectBox";

export type ClientShopSelectorProps = {
  clientShopId: number | undefined;
  onClientShopChange: (clientShopId: number | undefined) => void;
  clientShops: readonly { value: number; label: string }[];
};

export const ClientShopSelector = (props: ClientShopSelectorProps) => {
  const { clientShopId, onClientShopChange, clientShops } = props;

  return (
    <div className="js-new-scout-shop-select">
      <SearchableSelectBox
        value={clientShopId}
        onChange={onClientShopChange}
        options={clientShops}
        placeholder="店舗を選択する（入力して絞り込むこともできます）"
        noOptionsMessage="条件に一致する店舗がありません"
        instanceId="shop-selector"
      />
    </div>
  );
};
